class FXFlashSale extends HTMLElement {
  constructor() {
    super();
    // Initialize properties from data attributes
    this.isStartFlashSale = this.dataset.startFlashSale === 'true';
    this.isEndFlashSale = this.dataset.endFlashSale === 'true';
    this.Date = this.dataset.flashSaleDate;
    this.Time = this.dataset.flashSaleTime;
    this.flashSaleCarousel = this.querySelector('.flashsale-carousel');
    this.defaultCarousel = this.querySelector('.default-carousel');
  }

  connectedCallback() {
    this.updateCarousel(); // Check and update carousel visibility on load
    this.scheduleUpdates(); // Schedule future updates based on flash sale timing
  }

  getDateTime() {
    // Parse date and time from data attributes into a Date object
    const [day, month, year] = this.Date.split('/').map(Number);
    const [hours, minutes, seconds] = this.Time.split(':').map(Number);
    return new Date(year, month - 1, day, hours, minutes, seconds);
  }

  updateCarousel() {
    const dateTime = this.getDateTime(); // Get the flash sale start/end time
    const now = new Date();
    const isFlashSaleActive = now >= dateTime;

    if (this.isEndFlashSale) {
      this.toggleCarousel(!isFlashSaleActive); // Hide flash sale carousel after it ends
    } else if (this.isStartFlashSale) {
      this.toggleCarousel(isFlashSaleActive); // Show flash sale carousel when it starts
    }
  }

  toggleCarousel(showFlashSale) {
    // Toggle visibility between flash sale and default carousels
    this.flashSaleCarousel.style.display = showFlashSale ? 'block' : 'none';
    this.defaultCarousel.style.display = showFlashSale ? 'none' : 'block';
  }

  scheduleUpdates() {
    const dateTime = this.getDateTime();
    const now = new Date();
    const timeUntilChange = dateTime - now;

    if (timeUntilChange > 0) {
      // Schedule a carousel update when the flash sale starts or ends
      setTimeout(() => this.updateCarousel(), timeUntilChange);
    }
  }
}

// Define the custom element 'fx-flash-sale'
customElements.define('fx-flash-sale', FXFlashSale);
